import React, { useState } from "react";
import "./CommunityPartnerships.css";
import registerbg from "../../assets/register-bg.png";
import logo from "../../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { useRef, useMemo } from "react";

import { defaultCountries, parseCountry, FlagImage } from "react-international-phone";
import "react-international-phone/style.css";

export default function CommunityPartnerships() {

  const navigate = useNavigate();
const [showSuccess, setShowSuccess] = useState(false);

  const [username, setUsername] = useState("");
  const [delegateName, setDelegateName] = useState("");
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");
  const [code, setCode] = useState("+20");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
    const dropdownRef = useRef(null);
  
  const countries = useMemo(
    () => defaultCountries.map(parseCountry),
    []
  );
  
  const [isOpen, setIsOpen] = useState(false);
  const [selectedIso2, setSelectedIso2] = useState("eg");
    
  

  const [area, setArea] = useState("");
  const [countBranches, setCountBranches] = useState("");
  const [period, setPeriod] = useState("");

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const validate = () => {
    let temp = {};

    if (!username.trim()) temp.username = "هذا الحقل مطلوب";
    if (!delegateName.trim()) temp.delegateName = "اسم المندوب مطلوب";
    

//  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     // if (!emailPattern.test(email)) temp.email = "البريد الإلكتروني مطلوب ";
//     if (!email.trim()) {
//   temp.email = "البريد الإلكتروني مطلوب";
// } else if (!emailPattern.test(email)) {
//   temp.email = "يرجى إدخال بريد إلكتروني صالح";
// }
    if (!phone) temp.phone = "رقم الجوال مطلوب";
    if (phone && (phone.length < 7 || phone.length > 12))
      temp.phone = " يرجى ادخال رقم هاتف صحيح";


    if (!country.trim()) temp.country = "الدولة مطلوبة";
    if (!city.trim()) temp.city = "المدينة مطلوبة";
    if (!address.trim()) temp.address = "العنوان مطلوب";

    // if (!area.trim()) temp.area = "المنطقة مطلوبة";
    // if (!countBranches) temp.countBranches = "عدد الفروع مطلوب";
    // if (!period) temp.period = "مدة الشراكة مطلوبة";
    const handleFieldChange = (field, value) => {
  let error = "";

  if (field === "username" && !value.trim()) {
    error = "هذا الحقل مطلوب";
  }

  if (field === "delegateName" && !value.trim()) {
    error = "اسم المندوب مطلوب";
  }

  if (field === "phone") {
    if (!value) {
      error = "رقم الجوال مطلوب";
    } else if (value.length < 7 || value.length > 12) {
      error = "يرجى ادخال رقم هاتف صحيح";
    }
  }

  if (field === "country" && !value.trim()) {
    error = "الدولة مطلوبة";
  }

  if (field === "city" && !value.trim()) {
    error = "المدينة مطلوبة";
  }

  if (field === "address" && !value.trim()) {
    error = "العنوان مطلوب";
  }

  setErrors((prev) => ({
    ...prev,
    [field]: error,
  }));
};

    setErrors(temp);
    return Object.keys(temp).length === 0;

  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setApiError("");

    // Email/Password 
    const autoEmail = `${phone}@partner.com`;
    const autoPassword = `${phone}A@`;

    try {
   const formData = new FormData();
formData.append("type", "customer");
formData.append("username", username);
// formData.append("delegate_name", delegateName);
formData.append("email", autoEmail);
formData.append("password", autoPassword);
formData.append("country", country);
formData.append("city", city);
formData.append("code_phone", code);

formData.append("phone", phone);
formData.append("address", address);
formData.append("activity_type", "company");
formData.append("area", area || "Cairo");
// formData.append("count_branches", countBranches ? Number(countBranches) : 3);
// formData.append("period", period ? Number(period) : 1);
formData.append("count_branches", countBranches || "3");
formData.append("period", period || "1");
// if (image) formData.append("image", image);
  const response = await axios.post(
    `${BaseUrl}${BuyerServicesUrl.Register}`,
    formData,
    // {
    //   headers: { "Content-Type": "multipart/form-data" },
    // }
  );

  console.log("REGISTER SUCCESS", response.data);
//   Swal.fire({
//   icon: "success",
//   title: "تم بنجاح",
//   text: "تم إرسال الطلب بنجاح",
//   confirmButtonText: "تسجيل الدخول",
//   confirmButtonColor: "#1d3a77",
//   background: "#f7f7f7"
// }).then(() => {
//   navigate("/login");
// });
  // navigate("/login");
setShowSuccess(true);
    } catch (error) {
      console.log(error.response?.data || error.message);
      setApiError(error.response?.data?.message || "فشل إرسال الطلب");
    } finally {
      setLoading(false);
    }
  };
  const handleFieldChange = (field, value) => {
  setErrors((prev) => ({ ...prev, [field]: "" }));
};

  return (
    <div className="registeration">
      <div className="container-fluid">
        <div className="row">
          <div className="image col-12 col-md-6 p-0">
            <img src={registerbg} alt="Register" className="login-image" />
          </div>

          <div className="form col-12 col-md-6 text-end">
            <div className="text-center mb-3">
              <img src={logo} alt="logo" />
            </div>

            {/*  Form submit */}
            <form onSubmit={handleSubmit}>
              <label className="pb-2">الجهة المشاركة</label>
              <input
                className="form-control"
                placeholder="الجهة المشاركة"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
              {errors.username && (
                <small className="text-danger">{errors.username}</small>
              )}

              <br />

              <label className="pt-1">اسم المندوب</label>
              <input
                className="form-control pb-1 "
                placeholder="اسم المندوب"
                value={delegateName}
                onChange={(e) => setDelegateName(e.target.value)}
              />
              {errors.delegateName && (
                <small className="text-danger">{errors.delegateName}</small>
              )}

              <br />

              {/* <label className="pt-2 pb-2">رقم الجوال</label> */}
              {/* <div className="d-flex gap-2">
                  <input
                  className="form-control"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="100234567"
                />
                <select
                  className="form-control codephone"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                >
                  <option value="+20">+20</option>
                  <option value="+966">+966</option>
                  <option value="+971">+971</option>
                </select>

              
              </div> */}
              {/* <div className="regphone-row">
                <div className="code-dropdown"  ref={dropdownRef}>
                  <button
                    type="button"
                    className="code-dropdown-btn mx-1" style={{width:"82px",height:"75%"}}
                    onClick={() => setIsOpen((v) => !v)}
                  >
                    <span className="code-flag ">
                      <FlagImage  iso2={selectedIso2} />
                    </span>
              
                    <span className="code-dial">{code}</span>
              
                    <span className="code-arrow">▾</span>
                  </button>
              
                  {isOpen && (
                    <div className="code-dropdown-menu">
                      {countries.map((c) => (
                        <button
                          type="button"
                          key={c.iso2}
                          className="code-item"
                          onClick={() => {
                            setSelectedIso2(c.iso2);
                            setIsOpen(false);
                          }}
                        >
                          <span className="code-flag">
                            <FlagImage iso2={c.iso2} />
                          </span>
                          <span className="code-dial">+{c.dialCode}</span>
                          <span className="code-name">{c.name}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              
                <input
                  className="phone-number-input text-end"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="ادخل رقم الجوال"
                  inputMode="numeric"
                  dir="rtl"
                />
              </div>
              
              {errors.phone && (
                <small className="text-danger">{errors.phone}</small>
              )} */}
                <div className="field">
              <label className="pt-2">رقم الجوال</label>
              
              <div className="regphone-row">
                <div className="code-dropdown" ref={dropdownRef}>
                  <button
                    type="button"
                    className="code-dropdown-btn"
                    onClick={() => setIsOpen((v) => !v)}
                  >
                    <span className="code-flag">
                      <FlagImage  iso2={selectedIso2} />
                    </span>
              
                    <span className="code-dial">{code}</span>
              
                    <span className="code-arrow">▾</span>
                  </button>
              
                  {isOpen && (
                    <div className="code-dropdown-menu">
                      {countries.map((c) => (
                        <button
                          type="button"
                          key={c.iso2}
                          className="code-item"
                          onClick={() => {
                            setSelectedIso2(c.iso2);
                            setIsOpen(false);
                          }}
                        >
                          <span className="code-flag">
                            <FlagImage iso2={c.iso2} />
                          </span>
                          <span className="code-dial">+{c.dialCode}</span>
                          <span className="code-name">{c.name}</span>
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              
              <input
                className="form-control phone-number-input text-end"
                value={phone}
                onChange={(e) => {
                  setPhone(e.target.value);
                  handleFieldChange("phone", e.target.value);
                }}
                placeholder="ادخل رقم الجوال"
              />
              </div>
              
              {errors.phone && <small className="text-danger">{errors.phone}</small>}
              
                         </div>

{/* 
              <div className="row mt-3">
              

                <div className="col-12 col-md-6 mb-2 text-end">
                  <label className="mb-2 fw-semibold">الدولة</label>
                  <input
                    className="form-control"
                    placeholder="الدولة"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                  />
                  {errors.country && (
                    <small className="text-danger">{errors.country}</small>
                  )}
                </div>
                  <div className="col-12 col-md-6 mb-3 text-end">
                  <label className="mb-2 fw-semibold">المدينة/المحافظة</label>
                  <input
                    className="form-control"
                    placeholder="المدينة/المحافظة"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                  {errors.city && (
                    <small className="text-danger">{errors.city}</small>
                  )}
                </div>
              </div>

              <div className="mb-3 text-end">
                <label className="mb-2 fw-semibold">العنوان</label>
                <input
                  className="form-control"
                  placeholder="العنوان"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
                {errors.address && (
                  <small className="text-danger d-block text-end">
                    {errors.address}
                  </small>
                )}
              </div>

              {apiError && (
                <div className="text-danger text-center mb-2">{apiError}</div>
              )} */}
             <div className="field">
       <div className="row ">
 
  {/* الدولة */}
  <div className="col-12 col-md-6 mb-2 text-end">
    <label className="mb-2 fw-semibold">الدولة</label>
    <input
      className="form-control"
      placeholder="الدولة"
      value={country}
      onChange={(e) =>{ setCountry(e.target.value);
        handleFieldChange("country", e.target.value);
      }}
    />
    {errors.country && (
      <small className="text-danger">{errors.country}</small>
    )}
  </div>
   {/* المدينة */}
  <div className="col-12 col-md-6 mb-3 text-end">
    <label className="mb-2 fw-semibold">المدينة/المحافظة</label>
    <input
      className="form-control"
      placeholder="المدينة/المحافظة"
      value={city}
      onChange={(e) => {setCity(e.target.value);
        handleFieldChange("city", e.target.value);
      }
      }
    />
    {errors.city && (
      <small className="text-danger">{errors.city}</small>
    )}
  </div>
</div>
<div className="field">
<div className=" text-end">
  <label className=" fw-semibold">العنوان</label>
  <input
    className="form-control"
    placeholder="العنوان"
    value={address}
    onChange={(e) =>{ setAddress(e.target.value);
              handleFieldChange("address", e.target.value);

    }
    }
  />
  {errors.address && (
    <small className="text-danger d-block text-end">
      {errors.address}
    </small>
  )}
</div>
</div>
</div>
              <button
                type="submit"
                className="btn w-100 text-white mt-3"
                disabled={loading}
              >
                {loading ? "جاري ارسال الطلب..." : "ارسال الطلب"}
              </button>

              <p className="text-center mt-3">
                تملك حساب؟{" "}
                <Link className="link" to="/login">
                  تسجيل الدخول
                </Link>
              </p>
            </form>
            {showSuccess && (
  <div className="success-modal-overlay">
    <div className="success-modal">
      <div className="success-icon">
        <i className="fa fa-check"></i>
      </div>

      <h3>تم بنجاح</h3>
      <p>تم إرسال الطلب بنجاح</p>

      <button
        className="success-btn"
        onClick={() => {
          setShowSuccess(false);
          navigate("/login");
        }}
      >
        تسجيل الدخول
      </button>
    </div>
  </div>
)}
          </div>
        </div>
      </div>
    </div>
  );
}